import styled from 'styled-components';
import { marginTop, marginRight, marginBottom, marginLeft, margin } from '../../styling/mixins/margin.js';

const Root = styled.table `
  ${marginTop};
  ${marginRight};
  ${marginBottom};
  ${marginLeft};
  ${margin};

  width: 100%;
  height: 100%;
  border-collapse: collapse;
`;

export { Root };
//# sourceMappingURL=styled.js.map
